import api from '@/api/clients/api';
import { DestinationGroup } from '@/features/destination-groups/api/types/destination-group';
import { Host } from '@/features/hosts/api/types/host';
import { PaginatedResponse } from '@/types/responses/paginated-response';

class DestinationGroupApi {
  async fetchDestinationGroups(
    page: number,
    perPage: number,
  ): Promise<PaginatedResponse<DestinationGroup>> {
    const { data } = await api.get<PaginatedResponse<DestinationGroup>>(
      `/destination-groups?page=${page}&perPage=${perPage}`,
    );

    return data;
  }

  async fetchDestinationGroup(destinationGroupId: number): Promise<DestinationGroup> {
    const { data } = await api.get<DestinationGroup>(`/destination-groups/${destinationGroupId}`);

    return data;
  }

  async createDestinationGroup(name: string, destinationsIds: number[]): Promise<DestinationGroup> {
    const { data } = await api.post<DestinationGroup>(`/destination-groups`, {
      name,
      destinationsIds,
    });

    return data;
  }

  async updateDestinationGroup(
    destinationGroupId: number,
    name: string,
    destinationsIds: number[],
  ): Promise<DestinationGroup> {
    const { data } = await api.put<DestinationGroup>(`/destination-groups/${destinationGroupId}`, {
      name,
      destinationsIds,
    });

    return data;
  }

  async removeDestinationGroup(destinationGroupId: number): Promise<DestinationGroup> {
    const { data } = await api.delete<DestinationGroup>(
      `/destination-groups/${destinationGroupId}`,
    );

    return data;
  }

  async addHostToDestinationGroup(destinationGroupId: number, hostId: number): Promise<Host> {
    const { data } = await api.post<Host>(
      `/destination-groups/${destinationGroupId}/hosts/${hostId}`,
    );

    return data;
  }

  async removeHostFromDestinationGroup(destinationGroupId: number, hostId: number): Promise<Host> {
    const { data } = await api.delete<Host>(
      `/destination-groups/${destinationGroupId}/hosts/${hostId}`,
    );

    return data;
  }

  async setGroupAsDefault(destinationGroupId: number): Promise<DestinationGroup> {
    const { data } = await api.post<DestinationGroup>(`/organization/default-destination-group`, {
      destinationGroupId,
    });

    return data;
  }

  async removeGroupFromDefault(): Promise<DestinationGroup> {
    const { data } = await api.delete<DestinationGroup>(`/organization/default-destination-group`);

    return data;
  }
}

export const destinationGroupApi = new DestinationGroupApi();
